<div class="container-fluid ml-n2">
  <div class="col-12 mt-2">
    <label class="sub-title-style">{{ $t(getSystemResourceKey) }}</label>
  </div>
  <div class="col-12 mt-4">
    <router-view />
  </div>
</div>